const encodeRedirectState = (path: string): string => {
  const bytes = new TextEncoder().encode(path);
  const binaryChars: string[] = [];

  for (const byte of bytes) {
    binaryChars.push(String.fromCodePoint(byte));
  }

  return btoa(binaryChars.join(''));
};

export default encodeRedirectState;
